const features = [
  {
    icon: 'ri-movie-2-line',
    title: '多平台聚合',
    desc: '一站式聚合香蕉视频、红桃视频、蜜桃视频等美食命名视频平台，无需切换应用，一个入口看遍所有。',
  },
  {
    icon: 'ri-hd-line',
    title: '高清流畅',
    desc: '全平台高清画质支持，智能自适应码率，播放不卡顿不缓冲，给你影院级观影体验。',
  },
  {
    icon: 'ri-speed-up-line',
    title: '极速更新',
    desc: '电视剧全集和最新电影实时同步更新，全网最快上架速度，追剧不等待，精彩不错过。',
  },
  {
    icon: 'ri-smartphone-line',
    title: '多端适配',
    desc: '完美适配手机、平板和电脑，随时随地打开浏览器就能追剧，无需下载任何应用。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="relative py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-12 md:mb-16">
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-3">
              为什么选择豆花视频
            </h2>
            <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
              聚合美食视频平台，为你打造极致的追剧观影体验
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
            {features.map((item, idx) => (
              <div
                key={idx}
                className="group bg-background-50 rounded-xl p-6 md:p-7 transition-all duration-300 hover:-translate-y-1"
              >
                <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-primary-100 text-primary-600 mb-5 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors duration-300">
                  <i className={`${item.icon} text-xl`}></i>
                </div>
                <h3 className="text-lg font-semibold text-foreground-900 mb-2">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {item.desc}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}